var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 29.4211C24.369 29.4211 23.4077 29.0219 22.6161 28.2237C21.8244 27.4254 21.4286 26.4561 21.4286 25.3158V17.1053C21.4286 15.9649 21.8244 14.9956 22.6161 14.1974C23.4077 13.3991 24.369 13 25.5 13C26.631 13 27.5923 13.3991 28.3839 14.1974C29.1756 14.9956 29.5714 15.9649 29.5714 17.1053V25.3158C29.5714 26.4561 29.1756 27.4254 28.3839 28.2237C27.5923 29.0219 26.631 29.4211 25.5 29.4211ZM24.1429 39V34.7921C21.7905 34.4728 19.8452 33.4123 18.3071 31.6105C16.769 29.8088 16 27.7105 16 25.3158H18.7143C18.7143 27.2088 19.3761 28.8221 20.6998 30.1559C22.0225 31.4906 23.6226 32.1579 25.5 32.1579C27.3774 32.1579 28.9779 31.4906 30.3016 30.1559C31.6243 28.8221 32.2857 27.2088 32.2857 25.3158H35C35 27.7105 34.231 29.8088 32.6929 31.6105C31.1548 33.4123 29.2095 34.4728 26.8571 34.7921V39H24.1429Z",
    fill: "#3485C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOn);
export default __webpack_public_path__ + "static/media/MicOn.9e1b1e778e793040525fead6eb3a573e.svg";
export { ForwardRef as ReactComponent };